<template>
  <div class="pattern">
    <div class="list" v-show="!isShow">
      <ul>
        <li>
          <div class="draw">
            <button @click="select(1)"></button>
          </div>
          <div><p>卡面装饰</p></div>
        </li>
        <li>
          <div class="font">
            <button @click="select(2)"></button>
          </div>
          <div><p>编辑文字</p></div>
        </li>
      </ul>
    </div>

    <div>
      <drawPicture
        v-show="isShow && patternType == 1"
        @selectImg="selectImg"
        @quit="quit"
      >
        <div class="custom">
            <span>旋转</span>
          <van-slider 
                v-model="rotateValue" 
                active-color="#ee0a24" 
                :style="{ width: '4.68rem', display: 'inline-block'}"
                :max="360"
                >
            <template #button>
              <div class="custom-button">{{ rotateValue }}</div>
            </template>
          </van-slider>
        </div>
      </drawPicture>

      <drawFont
        v-show="isShow && patternType == 2"
        v-on="$listeners"
        @quit2="quit2"
      >
        <div class="custom">
            <span>旋转</span>
          <van-slider 
            v-model="rotateValue" 
            active-color="#ee0a24" 
            :style="{ width: '4.68rem', display: 'inline-block'}"
            :max="360"
            >
            <template #button>
              <div class="custom-button">{{ rotateValue }}</div>
            </template>
          </van-slider>
        </div>
      </drawFont>
    </div>
  </div>
</template>

<script>
import drawFont from "./drawFont";
import drawPicture from "./drawPicture";
import { Slider } from "vant";

export default {
  inheritAttrs: false,
  components: {
    drawFont,
    drawPicture,
    [Slider.name]: Slider,
  },
  data() {
    return {
      isShow: false,
      patternType: 2,
      rotateValue: 0,
    };
  },
  methods: {
    select(type) {
      this.patternType = type;
      this.isShow = true;
      this.$emit("quit", !this.isShow);
    },
    selectImg(img) {
      this.$emit("selectImg", img);
    },
    quit(value) {
      this.isShow = value;
      this.$emit("quit", !this.isShow);
    },
    quit2(value) {
      console.log(value);
      this.isShow = value;
      this.$emit("quit", !value);
    },
    // onChange(value){
    //     console.log(value)
    // }
  },
  watch:{
      rotateValue(value){
         this.$emit("rotate",value)
      }
  }
};
</script>
<style lang="scss" scoped>
.custom-button {
  width: 26px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: #ee0a24;
  border-radius: 100px;
}
.pattern {
  background: white;
  .list {
    ul {
      @include flexBox(space-around);
      margin-top: 0.2rem;
      padding-top: 0.5rem;
      border-top: 1px solid #e4e4e4;
      li {
        text-align: center;
        p {
          margin: 0.1rem 0;
        }
      }
    }
    .draw {
      button {
        width: 1.26rem;
        height: 1.26rem;
        background: url("../../../../../../assets/icon/draw.png") white 50%/0.8rem
          no-repeat;
        border: none;
        border-radius: 50%;
      }
    }
    .font {
      @extend .draw;
      button {
        background: url("../../../../../../assets/icon/font.png") white 50%/0.8rem
          no-repeat;
      }
    }
   
  }
   .custom{
       width: 5.7rem;
       text-align: center;
       margin: auto;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        @include flexBox(space-between)
    }
}
</style>